var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentName,_vm._b({tag:"component",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var loaded = ref.loaded;
return [(!loaded && _vm.inScrollView)?_c('pdf-skeleton',{attrs:{"height":_vm.viewport.height}}):_vm._e()]}}])},'component',{
        page: _vm.page,
        scale: _vm.scale,
        viewport: _vm.viewport,
        inScrollView: _vm.inScrollView,
        elementStyle: _vm.elementStyle,
        isScrolling: _vm.isScrolling,
        watermarkText: _vm.watermarkText
    },false))}
var staticRenderFns = []

export { render, staticRenderFns }